import React from 'react';
import { Route } from 'react-router-dom';
import WarehouseLayout from '../views/Warehouse/WarehouseLayout';
import WarehouseDashboard from '../views/Warehouse/WarehouseDashboard';

const warehouseRoutes = (
  <Route path="/warehouse" element={<WarehouseLayout />}>
    <Route index element={<WarehouseDashboard />} />
  </Route>
);

export default warehouseRoutes;
